import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// 组件中导入图片
import icon_thead_zy from "../assets/icon/icon_thead_zy.png";
import logo_pc from "../assets/logo/logo_pc.png";
import icon_head_gzz from "../assets/icon/icon_head_gzz.png";
import icon_head_mlzy from "../assets/icon/icon_head_mlzy.png";
import icon_head_mygzz from "../assets/icon/icon_head_mygzz.png";

const path = [
  { path: "/", text: "网站首页" },
  { path: "/zoujinsihui", text: "医院介绍" },
  { path: "/sihuikeshi", text: "科室导航" },
  { path: "/lumgzz", text: "刘鲁明工作站" },
  { path: "/huizhenzhongxin", text: "肿瘤会诊中心" },
  {
    path: "/zhongyiyuzheng",
    external: "https://yt.sihuizhongyi.com/",
    text: "中医郁证基地",
  },
  { path: "/yibaofuwu", text: "医保服务" },
  { path: "/laiyuandaohang", text: "来院导航" },
];

export default function Header() {
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState(location.pathname); // 初始路径匹配首页
  const navigate = useNavigate();

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location.pathname]); // 依赖location.pathname变化

  const handleClick = (e, path) => {
    e.preventDefault();
    if (location.pathname !== path) {
      // 仅不同路径时跳转
      setCurrentPath(path);
      navigate(path);
    }
  };
  return (
    <div style={{ background: "#fff" }}>
      <div className="header_top">
        <div className="pageCon">
          聚全国名医 为人民服务
          <div className="fr">
            <a href="https://www.sihuizhongyi.com/">
              <img src={icon_thead_zy} alt="" />
              四惠总院
            </a>
            <a href="https://www.sihuixiqu.com/">
              <img src={icon_thead_zy} alt="" />
              四惠西区
            </a>
            <a href="https://www.bjsxt120.com/">
              <img src={icon_thead_zy} alt="" />
              四惠南区
            </a>
            <a onClick={() => navigate("/")}>
              <img src={icon_thead_zy} alt="" />
              杭州四惠
            </a>
            <a href="https://www.sihuiyiliao.com/">
              <img src={icon_thead_zy} alt="" />
              四惠医疗互联网医院
            </a>
          </div>
        </div>
      </div>
      <header>
        <div className="pageCon">
          <div className="logo fl">
            <a onClick={() => navigate("/")}>
              <img className="fl" src={logo_pc} alt="杭州四惠医院" />
              <h1>杭州四惠医院</h1>
            </a>
          </div>
          <ul className="head_name fl">
            <li>
              <a onClick={() => navigate("/huizhenzhongxin")}>
                <img
                  src={icon_head_gzz}
                  alt="北京市中西医结合肿瘤会诊中心合作医院"
                />
                北京市中西医结合肿瘤会诊中心合作医院
              </a>
            </li>
            <li>
              <a href="https://yt.sihuizhongyi.com/">
                <img
                  src={icon_head_mlzy}
                  alt="北京市中医郁证临床创新示范基地合作医院"
                />
                北京市中医郁证临床创新示范基地合作医院
              </a>
            </li>
            <li>
              <a onClick={() => navigate("/lumgzz")}>
                <img src={icon_head_gzz} alt="中国中医科学院眼科医院医联体" />
                上海市名中医刘鲁明教授（杭州）工作站
              </a>
            </li>
            <li>
              <a>
                <img src={icon_head_mygzz} alt="北京中医药薪火传承“3+3”" />
                北京中医药薪火传承“3+3”刘鲁明名医传承工作站
              </a>
            </li>
          </ul>
          <div className="head_fr fr">
            <div className="head_tel">
              <p>咨询热线</p>
              <p>0571-88685312</p>
            </div>
            <div className="search_head" name="formsearch">
              <form action="/" name="formsearch">
                <input
                  className="search_input"
                  type="text"
                  name="keyword"
                  placeholder="请输入您要查询的内容"
                  style={{ color: "#d1abac" }}
                ></input>
                <input className="search_btn" type="submit" value=""></input>
                <div className="clear"></div>
              </form>
            </div>
          </div>
        </div>
      </header>
      <div className="clear"></div>
      <nav>
        <div className="pageCon">
          <ul className="NavUl">
            {path.map((item) => {
              return (
                <li
                  key={item.path}
                  className={currentPath === item.path ? "active" : ""}
                >
                  {item.external ? (
                    // 外部链接处理
                    <a
                      href={item.external}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => {
                        e.preventDefault();
                        window.open(item.external, "_blank"); // 新窗口打开
                      }}
                    >
                      {item.text}
                    </a>
                  ) : (
                    // 内部路由处理
                    <a
                      href={item.path}
                      onClick={(e) => handleClick(e, item.path)}
                    >
                      {item.text}
                    </a>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </nav>
    </div>
  );
}
